import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { MapService } from '../../map/services/map.service';

/**
 * Component to save a geographic location.
 */
@Component({
  selector: 'save-location',
  templateUrl: './save-location.component.html',
  styleUrl: './save-location.component.css'
})
export class SaveLocationComponent implements OnInit {
	@Input() locationData: any;
	
	LOCALIZATION: any;
	
	name: string = '';
	
	constructor(
		private modalService: NgbActiveModal,
		private userService: UserService,
		private alertsService: AlertsService,
		private mapService: MapService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		
		console.log('locationData:', this.locationData);
		
		this.name = this.locationData?.location?.name || '';
	}
	
	/**
	 * Persists the location.
	 */
	save(): void {
		if (this.locationData.geo) {
		    let payload = {
				geo: this.locationData.geo,
				name: this.name
			};
			
		    this.mapService.addLocation(payload).then(
				(response: any) => {
			        this.alertsService.success({
			            message: "Successfully saved this location."
			        });
			        this.closeWithResponse(response.data);
			    }, 
				() => {
			        this.alertsService.error({
			            message: "Failed to save this location."
			        });
			    }
			);
		} else {
		    let payload = {
				name: this.name
			};
			
		    this.mapService.updateLocation(this.locationData.location.id, payload).then(
				(response: any) => {
			        this.alertsService.success({
			            message: "Successfully updated this location."
			        });
			        this.closeWithResponse(response.data);
			    }, 
				() => {
			        this.alertsService.error({
			            message: "Failed to update this location."
			        });
			    }
			);
		}
	}
	
	/**
	 * Closes the modal and includes a payload.
	 */
	closeWithResponse(result?: any): void {
		let caller = {
			callerName: 'saveLocation'
		};
				
		this.modalService.close({answer: 'ok', location: result, caller: caller });
	}
	
	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}	
}
